import { data } from '../../svg/Repeat/data';
import { makeIcon } from '../makeIcon';

export const Repeat = makeIcon(data, 'repeat', 'Repeat');

export default Repeat;
